import {
  apiRoutes,
  type DefaultQueryError,
  getPaymentTransactionStatusFn,
  type TransactionResponse,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetPaymentTransactionStatus = (
  id: string,
  opts?: Omit<
    UseQueryOptions<TransactionResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<TransactionResponse, DefaultQueryError>({
    queryKey: [apiRoutes.payment.transaction_status_private, id],
    queryFn: () => getPaymentTransactionStatusFn(id),
    ...opts,
  });
